import {ActiveUserEvent} from '@mintdata-wsp/wsp/controllers/multiplayer/MultiplayerController';
import {observer} from 'mobx-react';
import React from 'react';
import * as classnames from 'classnames/bind';
import {Column} from '@mintdata-wsp/wsp/ui/components/forms/Column';
import {Row} from '@mintdata-wsp/wsp/ui/components/forms/Row';
import {rootState} from '@mintdata-wsp/common/state/RootState';
import {UserIcon, UserIconSize} from './UserIcon';

const styles = require('./UserIconPopupCard.less');
const cx = classnames.bind(styles);

export interface UserIconPopupCardProps
{
    user:ActiveUserEvent;
}

@observer
export class UserIconPopupCard extends React.Component<UserIconPopupCardProps, any>
{
    constructor(props:any)
    {
        super(props);
    }

    render()
    {
        const {activeUsers} = rootState.ui.visualDesigner;

        let {user} = this.props;
        const userDetails = activeUsers.otherUsersDetails.get(user.userId);

        if( !userDetails )
            return null;

        const userStates = [];

        if( userDetails.isIdle )
            userStates.push('idle');

        if( user.userId === activeUsers.followingUserId )
            userStates.push('observing');

        return (
            <Column className={cx('cardContainer')}>
                <Row key={user.userId} className={cx('userIconPopupCard')}>
                    <Column className={cx('nameInitialsColumn')}>
                        <UserIcon
                            iconSize={UserIconSize.LargeNoMargin}
                            noGrayBorder
                            fullName={userDetails.fullName}
                            avatarUrl={userDetails.avatarUrl}
                            color={userDetails.color}
                            idle={userDetails.isIdle}
                        />
                    </Column>

                    <Column className={cx('contentColumn')}>
                        <Row className={cx('fullNameRow')}>
                            {userStates.length ? `${userDetails.fullName} (${userStates.join(', ')})` : userDetails.fullName}
                        </Row>
                    </Column>
                </Row>
            </Column>
        );
    }
}
